import { createSlice } from "@reduxjs/toolkit";
import {
    fetchPlanoList,
    salvarPlanoCompleto,
    removerPlano,
    setPlanoAtivo,
    editarPlano,
    trocarExercicioNoPlano,
} from "./thunks";
import { logoutAuth } from "../user/slice";
import {
    setTreinoAtivo,
    removerTreinoDaAPI,
    adicionarTreinoAoPlano,
    atualizarTreinoNoPlano,
} from "../treinos/thunks";

const initialState = {
    planos: [],
    loading: false,
};

const handlePending = (state) => { state.loading = true; };
const handleRejected = (state) => { state.loading = false; };

const planosSlice = createSlice({
    name: "planos",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPlanoList.pending, handlePending)
            .addCase(fetchPlanoList.rejected, handleRejected)
            .addCase(fetchPlanoList.fulfilled, (state, action) => {
                state.planos = action.payload;
                state.loading = false;
            })
            .addCase(salvarPlanoCompleto.pending, handlePending)
            .addCase(salvarPlanoCompleto.rejected, handleRejected)
            .addCase(salvarPlanoCompleto.fulfilled, (state, action) => {
                state.loading = false;
                state.planos.push(action.payload);
            })
            .addCase(removerPlano.pending, handlePending)
            .addCase(removerPlano.rejected, handleRejected)
            .addCase(removerPlano.fulfilled, (state, action) => {
                state.loading = false;
                state.planos = state.planos.filter(
                    (p) => String(p.id) !== String(action.payload)
                );
            })
            .addCase(setPlanoAtivo.pending, handlePending)
            .addCase(setPlanoAtivo.rejected, handleRejected)
            .addCase(setPlanoAtivo.fulfilled, (state, action) => {
                state.loading = false;
                state.planos.forEach((plano) => {
                    plano.ativo = String(plano.id) === String(action.payload.idPlano);
                    if (plano.ativo && plano.rotina) {
                        plano.rotina.forEach(t => { t.ativo = false; });
                    }
                });
            })
            .addCase(editarPlano.pending, handlePending)
            .addCase(editarPlano.rejected, handleRejected)
            .addCase(editarPlano.fulfilled, (state, action) => {
                state.loading = false;
                const idx = state.planos.findIndex(p => String(p.id) === String(action.payload.id));
                if (idx !== -1) state.planos[idx] = action.payload;
            })
            .addCase(setTreinoAtivo.fulfilled, (state, action) => {
                const idx = state.planos.findIndex(p => String(p.id) === String(action.payload.idPlano));
                if (idx !== -1 && state.planos[idx].rotina) {
                    state.planos[idx].rotina.forEach(t => { t.ativo = String(t.dia) === String(action.payload.dia); });
                }
            })
            .addCase(removerTreinoDaAPI.fulfilled, (state, action) => {
                if (action.payload.action !== 'removed_full_plan_or_cancelled') {
                    const idx = state.planos.findIndex(p => String(p.id) === String(action.payload.id));
                    if (idx !== -1) {
                        state.planos[idx].rotina = state.planos[idx].rotina.filter(item => item.dia !== action.payload.dia);
                    }
                }
            })
            .addCase(adicionarTreinoAoPlano.fulfilled, (state, action) => {
                const idx = state.planos.findIndex(p => String(p.id) === String(action.payload.id));
                if (idx !== -1) state.planos[idx] = action.payload;
            })
            .addCase(atualizarTreinoNoPlano.fulfilled, (state, action) => {
                const idx = state.planos.findIndex(p => String(p.id) === String(action.payload.id));
                if (idx !== -1) state.planos[idx] = action.payload;
            })
            .addCase(trocarExercicioNoPlano.pending, handlePending)
            .addCase(trocarExercicioNoPlano.rejected, handleRejected)
            .addCase(trocarExercicioNoPlano.fulfilled, (state) => {
                // Não atualiza o estado diretamente pois o payload vem sem hidratação
                // (sem dica_tecnica, substitutos, ids normalizados).
                // O fetchPlanoList() despachado pelo thunk cuida da atualização completa.
                state.loading = false;
            })
            // Limpa os planos ao fazer logout para evitar vazamento de dados entre sessões
            .addCase(logoutAuth.fulfilled, (state) => {
                state.planos = [];
                state.loading = false;
            });
    }
});

export * from './thunks';
export default planosSlice.reducer;
